import { Injectable } from '@angular/core';
import {VoipPeersDialogComponent} from './voip-peers-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {VoipPeerApiService} from '../../../services/api/network/online/voip-peer/voip-peer-api.service';
import {SnackBarService} from '../../../services/common/snack-bar/snack-bar.service';
import * as _ from 'lodash';
import {CacProfilesApiService} from '../../../services/api/routing/cac-profiles/cac-profiles-api.service';
import Search from '../../../utils/search';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {LogicalConjunctionService} from '../../../services/common/logical-conjunction/logical-conjunction.service';

@Injectable({
  providedIn: 'root'
})
export class VoipPeersDialogService {

  constructor(private dialog: MatDialog,
              private snackBarService: SnackBarService,
              private cacProfilesApiService: CacProfilesApiService,
              private logicalConjunctionService: LogicalConjunctionService,
              private voipPeerApiService: VoipPeerApiService) { }

  add(voipPeer, onSuccess = () => {}, onFailure = () => {}): void {
    this.cacProfilesApiService.getCacProfiles().subscribe(cacProfiles => {
      const dialogRef = this.dialog.open(VoipPeersDialogComponent, {
        data: {
          isEditMode: false,
          selectedItem: _.cloneDeep(voipPeer),
          cacProfiles: Search.generateSearchOptions(cacProfiles.elements, 'name', 'id')
        }
      });

      dialogRef.componentInstance.onApply.subscribe(result => {
        this.voipPeerApiService.addVoipPeer(result.selectedItem).then(() => {
          dialogRef.close();
          this.snackBarService.display(`"${result.selectedItem.name}" successfully added`);
          onSuccess();
        });
      });

      dialogRef.componentInstance.onCancel.subscribe(() => {
        onFailure();
      });
    });
  }

  edit(voipPeer, onSuccess = () => {}, onFailure = () => {}): void {
    this.cacProfilesApiService.getCacProfiles().subscribe(cacProfiles => {
      const dialogRef = this.dialog.open(VoipPeersDialogComponent, {
        data: {
          isEditMode: true,
          selectedItem: _.cloneDeep(voipPeer),
          cacProfiles: Search.generateSearchOptions(cacProfiles.elements, 'name', 'id')
        }
      });

      dialogRef.componentInstance.onApply.subscribe(result => {
        this.voipPeerApiService.editVoipPeer(result.selectedItem, result.selectedItem.id).then(() => {
          dialogRef.close();
          this.snackBarService.display(`"${result.selectedItem.name}" successfully edited`);
          onSuccess();
        });
      });

      dialogRef.componentInstance.onCancel.subscribe(() => {
        onFailure();
      });
    });
  }

  delete(voipPeers, onSuccess = () => {}, onFailure = () => {}): void {
    const ids = voipPeers.map(voipPeer => voipPeer.id);
    const voIPPeersNames = this.logicalConjunctionService.generateAndDescription(voipPeers, 'name');

    const confirmationMessage = `Are you sure you want to delete ${ids.length === 1 ?
      `the VoIP peer: "${voipPeers[0].name}"` :
      `${ids.length} VoIP Peers: ${voIPPeersNames}`} ?`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.voipPeerApiService.deleteVoipPeers(ids).then(() => {
        dialogRef.close();
        onSuccess();
        this.snackBarService.display(`${voIPPeersNames} successfully deleted`);
      });
    });

    dialogRef.componentInstance.onCancel.subscribe(() => {
      onFailure();
    });
  }
}
